import React from "react";
import PrayerButtonGrid from "../components/PrayerButtonGrid";
import { Container, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";


const categories = [
  "wisdom_prayer",
  "peace_prayer",
  "patience_prayer",
  "gratitude_prayer",
  "faith_prayer",
  "forgiveness_prayer",
  "guidance_prayer",
  "strength_prayer",
  "boyfriend",
  "girlfriend",
  "purpose_prayers",
  "anxiety_prayers",
  "dog_prayer",
  "cat_prayer"

];

const labels = {
  wisdom_prayer: "Мудрость",
  peace_prayer: "Покой",
  patience_prayer: "Терпение",
  gratitude_prayer: "Благодарность",
  faith_prayer: "Вера",
  forgiveness_prayer: "Прощение",
  guidance_prayer: "Руководство",
  strength_prayer: "Сила",
  boyfriend: "Парень",
  girlfriend: "Девушка",
  purpose_prayers: "Цель",
  anxiety_prayers: "Тревога",
  dog_prayer: "Собака",
  cat_prayer: "Кошка"
};

function RussianMorePage() {
  const navigate = useNavigate();

  return (
    <Container className="mt-4">
      <h1 className="text-center mb-4">Больше Молитв</h1>
      <PrayerButtonGrid
        categories={categories}
        labels={labels}
        onSelect={(cat) =>
          navigate(`/ru/prayer/${cat}`, { state: { from: "/ru/more" } })
        }
      />
      <div className="text-center mt-4">
        <Button className="glass-button bg-transparent border-0" onClick={() => navigate("/ru")}>
          Назад на Главную
        </Button>
      </div>
    </Container>
  );
}

export default RussianMorePage;

